/*eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";

import StatewideMain from "@/views/statewide/statewide-main.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'StatewideMain',
        component: StatewideMain,
    },
]

const router = new VueRouter({
    routes,
    mode: 'history'
});

export default router;